import React, { useState } from 'react';
import axios from '../utils/axiosConfig';
import '../styles/EnquiryForm.css';
import { trackDemoRequest } from '../utils/analytics';

function EnquiryForm({ onClose }) {
  const [formData, setFormData] = useState({ name: '', email: '', mobile: '', message: '' });
  const [notification, setNotification] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/api/enquiry/submit', formData);
      
      if (response.status === 200) {
        trackDemoRequest('contact_form');
        setNotification({ type: 'success', message: 'Thank you for your enquiry. We will get back to you soon.' });
        setTimeout(() => {
          setNotification(null);
          onClose();
        }, 3000);
      } else {
        throw new Error('Failed to send enquiry');
      }
    } catch (error) {
      console.error('Error:', error);
      setNotification({ type: 'error', message: error.message || 'Failed to send enquiry. Please try again later.' });
    }
  };

  return (
       <div className="enquiry-form-overlay" onClick={(e) => {
      // Close when clicking on the overlay background but not on the form
      if (e.target.className === 'enquiry-form-overlay') {
        onClose();
      }
    }}>
      <div className="enquiry-form-container">
        <button className="close-btn" onClick={onClose}>&times;</button>
        <h2>Enquire Now</h2>
        
        {notification && (
          <div className={`notification ${notification.type}`}>
            {notification.type === 'success' && (
              <span>✓</span>
            )}
            {notification.type === 'error' && (
              <span>⚠</span>
            )}
            {notification.message}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="eform-form-group">
            <label className="lp-label">Your Name</label>
            <input
              type="text"
              name="name"
              className="lp-input"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="lp-form-group">
            <label className="lp-label">Your Email</label>
            <input
              type="email"
              name="email"
              className="lp-input"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="lp-form-group">
            <label className="lp-label">Your Mobile Number</label>
            <input
              type="tel"
              name="mobile"
              className="lp-input"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="lp-form-group">
            <label className="lp-label">Your Message</label>
            <textarea
              name="message"
              className="lp-input lp-textarea"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          
          <button type="submit" className="lp-button primary">
            Send Enquiry
          </button>
        </form>
      </div>
    </div>
  );
}

export default EnquiryForm;